import { render } from "./Loading.vue?vue&type=template&id=546103af&scoped=true"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"

import "./Loading.vue?vue&type=style&index=0&id=546103af&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-546103af"

export default script